import React from 'react';
import { Link } from 'react-router-dom';
import './AboutUs.css';
import { LoginNavbar } from '../../components/layout/Navbar';
import missionImg from '../../assets/images/timesheet-aboutus-mission.png';
import visionImg from '../../assets/images/timesheet-aboutus-vision.png';
import valuesImg from '../../assets/images/timesheet-aboutus-values.png';

const Footer = ({ className }) => (
  <footer className={className || 'footer'}>
    @ EZ Timesheet Copyright Reserved
  </footer>
);

const AboutUs = () => {
  return (
    <>
      <LoginNavbar />
      <div className="about-container">
        <div className="about-back-button">
          <Link to="/login" className="back-button">
            ← Back to Login
          </Link>
        </div>
        <div className="about-hero">
          <div className="about-hero-content">
            <h1 className="about-title">About EZ Timesheet</h1>
            <p className="about-subtitle">
              Empowering organizations with efficient time tracking and expense management solutions
            </p>
          </div>
        </div>

        <div className="about-content">
          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">Our Mission</h2>
              <p className="about-section-text">
                At EZ Timesheet, we believe that time is the most valuable resource. Our mission is to 
                provide intuitive, reliable, and secure time tracking solutions that help businesses 
                optimize their operations, improve productivity, and make data-driven decisions.
              </p>
            </div>
            <div className="about-section-image">
              <img src={missionImg} alt="Our Mission" className="about-image-native" />
            </div>
          </div>

          <div className="about-section reverse">
            <div className="about-section-image">
              <img src={visionImg} alt="Our Vision" className="about-image-native" />
            </div>
            <div className="about-section-content">
              <h2 className="about-section-title">Our Vision</h2>
              <p className="about-section-text">
                We envision a world where time management is effortless and insightful. Through 
                innovative technology and user-centered design, we're building the future of 
                workforce management, one timesheet at a time.
              </p>
            </div>
          </div>

          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">What We Do</h2>
              <p className="about-section-text">
                EZ Timesheet offers comprehensive time and expense tracking solutions designed for 
                modern businesses. Our platform streamlines project management, enhances team 
                collaboration, and provides real-time insights into workforce productivity.
              </p>
              <div className="about-features">
                <div className="about-feature">
                  <div className="about-feature-icon">⏰</div>
                  <h3>Time Tracking</h3>
                  <p>Accurate and efficient time recording for projects and tasks</p>
                </div>
                <div className="about-feature">
                  <div className="about-feature-icon">💰</div>
                  <h3>Expense Management</h3>
                  <p>Streamlined expense reporting and approval workflows</p>
                </div>
                <div className="about-feature">
                  <div className="about-feature-icon">📊</div>
                  <h3>Analytics & Reporting</h3>
                  <p>Comprehensive insights and customizable reports</p>
                </div>
              </div>
            </div>
          </div>

          <div className="about-section reverse">
            <div className="about-section-image">
              <img src={valuesImg} alt="Our Values" className="about-image-native" />
            </div>
            <div className="about-section-content">
              <h2 className="about-section-title">Our Values</h2>
              <div className="about-values">
                <div className="about-value">
                  <h3>Innovation</h3>
                  <p>Continuously improving our solutions with cutting-edge technology</p>
                </div>
                <div className="about-value">
                  <h3>Reliability</h3>
                  <p>Providing stable and secure services you can count on</p>
                </div>
                <div className="about-value">
                  <h3>User Experience</h3>
                  <p>Designing intuitive interfaces that make work easier</p>
                </div>
                <div className="about-value">
                  <h3>Customer Success</h3>
                  <p>Supporting our clients in achieving their goals</p>
                </div>
              </div>
            </div>
          </div>

          <div className="about-cta">
            <h2>Ready to Get Started?</h2>
            <p>Join thousands of organizations already using EZ Timesheet</p>
            <Link to="/login" className="about-cta-button">
              Start Free Trial
            </Link>
          </div>
        </div>
      </div>
      <Footer className="about-footer" />
    </>
  );
};

export default AboutUs;
